// extracted by mini-css-extract-plugin
module.exports = {"connection-modal":"modal_connection-modal__8LGi_"};